var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ComplaintGroupBasedOnIdURL, ComplaintGroupURL, ComplaintsJobItemsSearchURL, ValidateOdometerUrl } from "../../../api/url";
import { createAPI, getByIdAPI, getListAPI } from "../../../redux/crudSlice";
import { appointmentDetailsGetByIdAPI, AppointmentKeys, appointmentPagingURL, channelInstallBaseURL, getCampaignListURL, repairTypeListURL, validateAppointmentURL } from "./entity";
import { store } from "../../../store/store";
import dayjs from "dayjs";
var dispatch = store.dispatch;
export var appointmentInstallBaseDetails = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _res$payload2, _res$payload3, _Customer$Address, _Customer$GivenName, _Customer$FamilyName, _Vehicle$ModelName, _Vehicle$ProductName, _res$payload4, _a, key, _b, request, _c, url, res, _d, Customer, InstallBase, address, Vehicle, data;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AppointmentKeys.InstallBase : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? channelInstallBaseURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _e.sent();
                if (!(res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success) || !(res !== null && res !== void 0 && (_res$payload2 = res.payload) !== null && _res$payload2 !== void 0 && (_res$payload2 = _res$payload2.value) !== null && _res$payload2 !== void 0 && _res$payload2.data))
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
                _d = res.payload.value.data, Customer = _d.Customer, InstallBase = _d.InstallBase;
                address = Customer === null || Customer === void 0 || (_Customer$Address = Customer.Address) === null || _Customer$Address === void 0 ? void 0 : _Customer$Address[0];
                Vehicle = InstallBase === null || InstallBase === void 0 ? void 0 : InstallBase[0];
                data = {
                    CustomerName: "".concat((_Customer$GivenName = Customer === null || Customer === void 0 ? void 0 : Customer.GivenName) !== null && _Customer$GivenName !== void 0 ? _Customer$GivenName : '', " ").concat((_Customer$FamilyName = Customer === null || Customer === void 0 ? void 0 : Customer.FamilyName) !== null && _Customer$FamilyName !== void 0 ? _Customer$FamilyName : ''),
                    Mobile: Customer === null || Customer === void 0 ? void 0 : Customer.MobileNumber,
                    Email: Customer === null || Customer === void 0 ? void 0 : Customer.Email,
                    Address: [address.Address1, address.Address2, address.Address3, address.Address4].map(function (it) { return it === null || it === void 0 ? void 0 : it.trim(); }).filter(Boolean).join(', '),
                    RegistrationNo: Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.RegistrationNo,
                    EngineNo: Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.EngineNo,
                    ChassisNo: Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.ChassisNo,
                    DateOfSale: dayjs(Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.SalesInvoiceDate).format('DD MMM, YYYY'),
                    Product: ((_Vehicle$ModelName = Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.ModelName) !== null && _Vehicle$ModelName !== void 0 ? _Vehicle$ModelName : '') + ' ' + ((_Vehicle$ProductName = Vehicle === null || Vehicle === void 0 ? void 0 : Vehicle.ProductName) !== null && _Vehicle$ProductName !== void 0 ? _Vehicle$ProductName : '')
                };
                return [2 /*return*/, _objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value), {}, {
                        data: data
                    })];
        }
    });
}); };
export var appointmentPagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AppointmentKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? appointmentPagingURL : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var translateToJobItemDetailsAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AppointmentKeys.TranslateToJobItems : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ComplaintGroupURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var jobItemsByGroupIdAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload7, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AppointmentKeys.ComplaintGroupBasedOnComplaintId : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ComplaintGroupBasedOnIdURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var getTranslateToJobItemSearchResultAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? AppointmentKeys.SearchTranslatetoJobItem : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ComplaintsJobItemsSearchURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
// const getSearchResult = async (searchTerm: string) => {
//     await dispatch(showLoader({ isLoaderOpen: true }));
//     let productID = documentDetailsGetById?.data ? documentDetailsGetById?.data?.Vehicle?.ProductId : ModuleDetailsGetById?.data ? ModuleDetailsGetById?.data?.Vehicle?.ProductId : vehicleList?.ProductId
//     let searchJobRequestBody = {
//         ProductId: productID,
//         Keyword: searchTerm,
//         ComplaintGroupIds: complaintsGroupsList.map((item: any) => item.id)
//     }
//     const searchResponse = await dispatch(getListAPI({ key: "", url: ComplaintsJobItemsSearchURL, request: searchJobRequestBody }))
//     if (searchResponse.payload?.value?.success && searchResponse.payload?.value?.data) {
//         setSearchResult(searchResponse.payload?.value?.data)
//     }
//     await dispatch(showLoader({ isLoaderOpen: false }));
// }
export var getAppointmentDetails = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'appointmentDetail' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? appointmentDetailsGetByIdAPI(request === null || request === void 0 ? void 0 : request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getRepairTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'repairTypeList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? repairTypeListURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var getCampaignList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'campaignList' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getCampaignListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var validateAppointmentAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? 'validateAppointment' : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? validateAppointmentURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.payload.value];
        }
    });
}); };
export var validateOdometerReading = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log("paramsss are", params);
                _a = params.key, key = _a === void 0 ? "validateOdometer" : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? ValidateOdometerUrl : _c;
                return [4 /*yield*/, dispatch(createAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                console.log("resss from odometer", res);
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
